import { io, Socket } from "socket.io-client";
import { Encryption } from "@cas/utilities";

const socketUrl = import.meta.env.VITE_WS_URL;

const socket: Socket = io(socketUrl, {
  path: "/api/socket_io",
  extraHeaders: {
    gameid: "dfcc8b45-d8a5-4418-814a-1c6ebdcc5bed",
    sessionid: new URLSearchParams(location.search).get("pyramidsid") || "",
  },
  withCredentials: true,
  secure: true,
});

type EventCallback<T = unknown> = (data: T) => void;

export const connectSocket = () => {
  socket.connect();
};

export const disconnectSocket = () => {
  socket.disconnect();
};

export const listenToEvent = <T = unknown>(event: string, callback: EventCallback<T>) => {
  try {
    socket.on(event, (data) => {
      const decrypted = Encryption.decrypt(data, event) as T;
      callback(decrypted);
    });
  } catch (error) {
    console.error(`Error listening to event "${event}":`, error);
  }
};

export const YantraWebsocketEvents = {
  keepAlive: "keep-alive",
  updateYantras: "kgsdnfakuwd32745213hjgk123321423d1",
  newYantras: "poizxc325437fd7875gdast5das4334asd",
  updateYantraTickets: "bdgsiyrtevc5432678df4231253cdsx543",
  newYantraTickets: "hfg5436783gdbfclp9576xzdaew432512",
  updateYantraExecutions: "bst5437cgdrtscax345267354vchdr8hf",
  newYantraExecutions: "h4323g038940b210b356056390abbfht3",
  yantraTimeChange: "hfbds2038940b2nj5356056390kjf75gd",
  forceLogout: "92343f038940b210b356056390ab45158",
  updateBalance: "81434f038940b210b356056390ab45267",
  listenYantra: "listenYantra",
  stopListenYantra: "stopListenYantra",
};

const emitEvent = (event: string, data: string) => {
  try {
    socket.emit(event, data);
  } catch (error) {
    console.error(`Error emitting event "${event}":`, error);
  }
};

export const removeListener = (event: string) => {
  try {
    socket.off(event);
  } catch (error) {
    console.error(`Error removing listener for event "${event}":`, error);
  }
};

export const listenYantra = (yantraId: string, zone: string) => {
  emitEvent(YantraWebsocketEvents.listenYantra, `${yantraId}_${zone}`);
};

export const stopListenYantra = (yantraId: string, zone: string) => {
  emitEvent(YantraWebsocketEvents.stopListenYantra, `${yantraId}_${zone}`);
};

socket.on("disconnect", () => {
  console.log("Socket disconnected");
});

export default socket;
